import { ColumnsType } from "../../types/baseTypes";

export const columnSize = (columns: ColumnsType[] | false) => {
  return (
    columns &&
    (columns
      .map((column) =>
        column.breakpoint
          ? `is-${column.number_of_cols}-${column.breakpoint.toLowerCase()}`
          : "",
      )
      .join(" ") as string)
  );
};

export const bulmaColumnsToWidth = (number_of_cols: number) => {
  return `${(number_of_cols / 12) * 100}%`;
};
